export const Types = {
    GET_TASK_DETAIL_BY_ID: "GET_TASK_DETAIL_BY_ID",
    GET_SAME_LEVEL_LIST_BY_ID: "GET_SAME_LEVEL_LIST_BY_ID",
    GET_BREAK_DOWN_ROOT_CAUSE_LIST: "GET_BREAK_DOWN_ROOT_CAUSE_LIST",

    SET_TASK_DETAIL_BY_ID: "SET_TASK_DETAIL_BY_ID",
    SET_SAME_LEVEL_LIST_BY_ID: "SET_SAME_LEVEL_LIST_BY_ID",
    SET_BREAK_DOWN_ROOT_CAUSE_LIST: "SET_BREAK_DOWN_ROOT_CAUSE_LIST",

    GET_BD_POOL_LIST: "GET_BD_POOL_LIST",
    SET_BD_POOL_LIST: "SET_BD_POOL_LIST",

    GET_BREAK_DOWN_REASON_LIST: "GET_BREAK_DOWN_REASON_LIST",
    SET_BREAK_DOWN_REASON_LIST: "SET_BREAK_DOWN_REASON_LIST",

    GET_BREAK_DOWN_REASON_R_POOL_LIST: "GET_BREAK_DOWN_REASON_R_POOL_LIST",
    SET_BREAK_DOWN_REASON_R_POOL_LIST: "SET_BREAK_DOWN_REASON_R_POOL_LIST",

    GET_BREAK_DOWN_EFFECT_LIST: "GET_BREAK_DOWN_EFFECT_LIST",
    SET_BREAK_DOWN_EFFECT_LIST: "SET_BREAK_DOWN_EFFECT_LIST",

    CREATE_SUBTASK_UNPLANNED_MAINTENANCE: "CREATE_SUBTASK_UNPLANNED_MAINTENANCE",
    CREATE_SUBTASK_UNPLANNED_MAINTENANCE_SUCCESS: "CREATE_SUBTASK_UNPLANNED_MAINTENANCE_SUCCESS",

    PLAY_UNPLANNED_MAINTENANCE: "PLAY_UNPLANNED_MAINTENANCE",
    START_UNPLANNED_MAINTENANCE: "START_UNPLANNED_MAINTENANCE",
    CLOSE_UNPLANNED_MAINTENANCE: "CLOSE_UNPLANNED_MAINTENANCE",
    CLOSE_MANY_UNPLANNED_TASKS: "CLOSE_MANY_UNPLANNED_TASKS",
    PAUSE_UNPLANNED_MAINTENANCE: "PAUSE_UNPLANNED_MAINTENANCE",
    REOPEN_UNPLANNED_MAINTENANCE: "REOPEN_UNPLANNED_MAINTENANCE",
    COMPLETE_UNPLANNED_MAINTENANCE: "COMPLETE_UNPLANNED_MAINTENANCE",

    ADD_TECHNICIAN_UNPLANNED_MAINTENANCE: "ADD_TECHNICIAN_UNPLANNED_MAINTENANCE",

    UPDATE_UNPLANNED_MAINTENANCE: "UPDATE_UNPLANNED_MAINTENANCE",
    SET_UPDATE_UNPLANNED_MAINTENANCE: "SET_UPDATE_UNPLANNED_MAINTENANCE",
    ASSIGN_UNPLANNED_MAINTENANCE: "ASSIGN_UNPLANNED_MAINTENANCE",

    GETLIST_BYSTATUS_UNPLANNED_MAINTENANCE: "GETLIST_BYSTATUS_UNPLANNED_MAINTENANCE",
    SETLIST_BYSTATUS_UNPLANNED_MAINTENANCE: "SETLIST_BYSTATUS_UNPLANNED_MAINTENANCE",

    GET_BDREASON_PLACELIST_BYGROUPID: "GET_BDREASON_PLACELIST_BYGROUPID",
    SET_BDREASON_PLACELIST_BYGROUPID: "SET_BDREASON_PLACELIST_BYGROUPID",

    GET_BDREASON_DETAILLIST_BYPLACEID: "GET_BDREASON_DETAILLIST_BYPLACEID",
    SET_BDREASON_DETAILLIST_BYPLACEID: "SET_BDREASON_DETAILLIST_BYPLACEID",
    GET_UNPLANNED_FILES: "GET_UNPLANNED_FILES",

    SET_UNPLANNED_FILES: "SET_UNPLANNED_FILES",
    ADD_UNPLANNED_FILES: "ADD_UNPLANNED_FILES",

    GET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE: "GET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE",
    SET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE: "SET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE",

    GET_MAINTENANCE_PAUSE_REASON_LIST: "GET_MAINTENANCE_PAUSE_REASON_LIST",
    SET_MAINTENANCE_PAUSE_REASON_LIST: "SET_MAINTENANCE_PAUSE_REASON_LIST",

    GET_TECH_LIST_FOR_BREAK_DOWN_DETAIL: "GET_TECH_LIST_FOR_BREAK_DOWN_DETAIL",
    SET_TECH_LIST_FOR_BREAK_DOWN_DETAIL: "SET_TECH_LIST_FOR_BREAK_DOWN_DETAIL",

    ADD_UNPLANNED_MAINTENANCE_OF_THE_REPORT: "ADD_UNPLANNED_MAINTENANCE_OF_THE_REPORT",
    GET_UNPLANNED_MAINTENANCE_OF_THE_REPORT: "GET_UNPLANNED_MAINTENANCE_OF_THE_REPORT",
    SET_UNPLANNED_MAINTENANCE_OF_THE_REPORT: "SET_UNPLANNED_MAINTENANCE_OF_THE_REPORT",
    DELETE_UNPLANNED_MAINTENANCE_OF_THE_REPORT: "DELETE_UNPLANNED_MAINTENANCE_OF_THE_REPORT",
    POST_UNPLANNED_MAINTENANCE_OF_THE_REPORT: "POST_UNPLANNED_MAINTENANCE_OF_THE_REPORT",
    SET_UNPLANNED_MAINTENANCE_OF_THE_REPORT_WITH_STATUS: "SET_UNPLANNED_MAINTENANCE_OF_THE_REPORT_WITH_STATUS",
    PATCH_UNPLANNED_MAINTENANCE_OF_THE_REPORT: "PATCH_UNPLANNED_MAINTENANCE_OF_THE_REPORT",
    UPDATE_REPORT_LIST: "UPDATE_REPORT_LIST",
    RESET_UPDATE_REPORT_LIST: "RESET_UPDATE_REPORT_LIST",

    IS_DELETED_REPORTS: "IS_DELETED_REPORTS",
    RESET_IS_DELETED_REPORTS: "RESET_IS_DELETED_REPORTS",

    SET_ACTION_REPONSE: "SET_ACTION_REPONSE",
    RESET_ACTION_REPONSE: "RESET_ACTION_REPONSE",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",

    DELETE_UNPLANNED_FILES: "DELETE_UNPLANNED_FILES",

    RESET_TECHNICIANS: "RESET_TECHNICIANS",
    RESET_ROOT_CAUSES: "RESET_ROOT_CAUSES",
    RESET_LIST_BYSTATUS_UNPLANNED_MAINTENANCE: "RESET_LIST_BYSTATUS_UNPLANNED_MAINTENANCE",
    RESET_BDREASON_PLACELIST_BYGROUPID: "RESET_BDREASON_PLACELIST_BYGROUPID",
    RESET_BREAK_DOWN_REASON_LIST: "RESET_BREAK_DOWN_REASON_LIST",
    RESET_BDREASON_DETAILLIST_BYPLACEID: "RESET_BDREASON_DETAILLIST_BYPLACEID",
    RESET_MAINTENANCE_PAUSE_REASON_LIST: "RESET_MAINTENANCE_PAUSE_REASON_LIST",
    RESET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE: "RESET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE",
    RESET_UNPLANNED_FILES: "RESET_UNPLANNED_FILES",
    RESET_BD_POOL_LIST: "RESET_BD_POOL_LIST",
    RESET_BREAK_DOWN_EFFECT_LIST: "RESET_BREAK_DOWN_EFFECT_LIST",
    RESET_SAME_LEVEL_LIST_BY_ID: "RESET_SAME_LEVEL_LIST_BY_ID",
    RESET_TASK_DETAIL_BY_ID: "RESET_TASK_DETAIL_BY_ID",
    RESET_CREATE_SUBTASK_UNPLANNED_MAINTENANCE_SUCCESS: "RESET_CREATE_SUBTASK_UNPLANNED_MAINTENANCE_SUCCESS",

    GET_EKED_EQUIPMENT_LIST_UNPLANNED: "GET_EKED_EQUIPMENT_LIST_UNPLANNED",
    SET_EKED_EQUIPMENT_LIST_UNPLANNED: "SET_EKED_EQUIPMENT_LIST_UNPLANNED",
    UPDATE_EKED_EQUIPMENT_LIST_UNPLANNED: "UPDATE_EKED_EQUIPMENT_LIST_UNPLANNED",

    GET_CURRENT_USERS_ACTIVE_TASK_ID: "GET_CURRENT_USERS_ACTIVE_TASK_ID",
    SET_CURRENT_USERS_ACTIVE_TASK_ID: "SET_CURRENT_USERS_ACTIVE_TASK_ID",
};

export const getTaskDetailById = (id) => ({
    type: Types.GET_TASK_DETAIL_BY_ID,
    payload: id,
});

export const getSameLevelListById = (id) => ({
    type: Types.GET_SAME_LEVEL_LIST_BY_ID,
    payload: id,
});

export const getBreakdownRootCauseList = (payload) => ({
    type: Types.GET_BREAK_DOWN_ROOT_CAUSE_LIST,
    payload,
});
export const setTaskDetailById = (payload) => ({
    type: Types.SET_TASK_DETAIL_BY_ID,
    payload: payload,
});

export const setSameLevelListById = (payload) => ({
    type: Types.SET_SAME_LEVEL_LIST_BY_ID,
    payload: payload,
});

export const setBreakdownRootCauseList = (payload) => ({
    type: Types.SET_BREAK_DOWN_ROOT_CAUSE_LIST,
    payload,
});
export const getBreakdownPoolList = (payload) => ({
    type: Types.GET_BD_POOL_LIST,
    payload,
});
export const setBreakdownPoolList = (payload) => ({
    type: Types.SET_BD_POOL_LIST,
    payload,
});
export const getBreakdownReasonList = (payload) => ({
    type: Types.GET_BREAK_DOWN_REASON_LIST,
    payload,
});
export const setBreakdownReasonList = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_LIST,
    payload,
});
export const getBreakdownReasonListWithPoolRelations = (payload) => ({
    type: Types.GET_BREAK_DOWN_REASON_R_POOL_LIST,
    payload,
});
export const setBreakdownReasonListWithPoolRelations= (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_R_POOL_LIST,
    payload,
});
export const getTechnicianList = (payload) => ({
    type: Types.GET_TECH_LIST_FOR_BREAK_DOWN_DETAIL,
    payload,
});
export const setTechnicianList = (payload) => ({
    type: Types.SET_TECH_LIST_FOR_BREAK_DOWN_DETAIL,
    payload,
});
export const getBreakdownEffectList = () => ({
    type: Types.GET_BREAK_DOWN_EFFECT_LIST,
});
export const setBreakdownEffectList = (payload) => ({
    type: Types.SET_BREAK_DOWN_EFFECT_LIST,
    payload,
});
export const createSubTask = (payload) => ({
    type: Types.CREATE_SUBTASK_UNPLANNED_MAINTENANCE,
    payload,
});
export const createSubTaskSuccess = (payload) => ({
    type: Types.CREATE_SUBTASK_UNPLANNED_MAINTENANCE_SUCCESS,
    payload,
});
export const playUnPlannedMaintenance = (payload) => ({
    type: Types.PLAY_UNPLANNED_MAINTENANCE,
    payload,
});

export const startUnPlannedMaintenance = (payload) => ({
    type: Types.START_UNPLANNED_MAINTENANCE,
    payload,
});
export const closeUnPlannedMaintenance = (payload) => ({
    type: Types.CLOSE_UNPLANNED_MAINTENANCE,
    payload,
});

export const closeManyUnplannedTasks = (payload) => ({
    type: Types.CLOSE_MANY_UNPLANNED_TASKS,
    payload,
});

export const pauseUnPlannedMaintenance = (payload) => ({
    type: Types.PAUSE_UNPLANNED_MAINTENANCE,
    payload,
});
export const reopenUnplannedMaintenance = (payload) => ({
    type: Types.REOPEN_UNPLANNED_MAINTENANCE,
    payload,
});
export const completeUnPlannedMaintenance = (payload) => ({
    type: Types.COMPLETE_UNPLANNED_MAINTENANCE,
    payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});

export const updateUnPlannedMaintenance = (payload) => ({
    type: Types.UPDATE_UNPLANNED_MAINTENANCE,
    payload,
});

export const addUnPlannedMaintenanceOfTheReport = (payload) => ({
    type: Types.ADD_UNPLANNED_MAINTENANCE_OF_THE_REPORT,
    payload,
});

export const getUnPlannedMaintenanceOfTheReport = (payload) => ({
    type: Types.GET_UNPLANNED_MAINTENANCE_OF_THE_REPORT,
    payload,
});

export const setUnPlannedMaintenanceOfTheReport = (payload) => ({
    type: Types.SET_UNPLANNED_MAINTENANCE_OF_THE_REPORT,
    payload,
});

export const deleteUnPlannedMaintenanceOfTheReports = (payload) => ({
    type: Types.DELETE_UNPLANNED_MAINTENANCE_OF_THE_REPORT,
    payload,
});

export const patchUnplannedMaintenanceOfTheReports = (payload) => ({
    type: Types.PATCH_UNPLANNED_MAINTENANCE_OF_THE_REPORT,
    payload,
});

export const updateReportList = () => ({
    type: Types.UPDATE_REPORT_LIST,
});

export const resetUpdateReportList = () => ({
    type: Types.RESET_UPDATE_REPORT_LIST,
});

export const postUnplannedMaintenanceOfTheReports = (payload) => ({
    type: Types.POST_UNPLANNED_MAINTENANCE_OF_THE_REPORT,
    payload,
});

export const setUnPlannedMaintenanceOfTheReportWithStatus = (payload) => ({
    type: Types.SET_UNPLANNED_MAINTENANCE_OF_THE_REPORT_WITH_STATUS,
    payload,
});

export const isDeletedReports = (payload) => ({
    type: Types.IS_DELETED_REPORTS,
    payload,
});

export const resetIsDeletedReports = (payload) => ({
    type: Types.RESET_IS_DELETED_REPORTS,
    payload,
});

export const addTechnician = (payload) => ({
    type: Types.ADD_TECHNICIAN_UNPLANNED_MAINTENANCE,
    payload,
});
export const assignTask = (payload) => ({
    type: Types.ASSIGN_UNPLANNED_MAINTENANCE,
    payload,
});
export const getListByStatusUnPlannedMaintenance = (payload) => ({
    type: Types.GETLIST_BYSTATUS_UNPLANNED_MAINTENANCE,
    payload,
});
export const setListByStatusUnPlannedMaintenance = (payload) => ({
    type: Types.SETLIST_BYSTATUS_UNPLANNED_MAINTENANCE,
    payload,
});
export const getBreakdownReasonPlaceListByGroupIdAndPoolRelations = (payload) => ({
    type: Types.GET_BDREASON_PLACELIST_BYGROUPID,
    payload,
});
export const setGetBreakdownReasonPlaceListByGroupIdAndPoolRelations = (payload) => ({
    type: Types.SET_BDREASON_PLACELIST_BYGROUPID,
    payload,
});
export const getBreakdownReasonDetailListByPlaceId = (payload) => ({
    type: Types.GET_BDREASON_DETAILLIST_BYPLACEID,
    payload,
});
export const setGetBreakdownReasonDetailListByPlaceId = (payload) => ({
    type: Types.SET_BDREASON_DETAILLIST_BYPLACEID,
    payload,
});
export const getUnplannedFiles = (payload) => ({
    type: Types.GET_UNPLANNED_FILES,
    payload,
});
export const setUnplannedFiles = (payload) => ({
    type: Types.SET_UNPLANNED_FILES,
    payload,
});
export const addUnplannedFiles = (payload) => ({
    type: Types.ADD_UNPLANNED_FILES,
    payload,
});
export const setActionResponse = (payload) => ({
    type: Types.SET_ACTION_REPONSE,
    payload,
});
export const getTaskHistoryByIdUnPlannedMaintenance = (payload) => ({
    type: Types.GET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE,
    payload,
});
export const setGetTaskHistoryByIdUnPlannedMaintenance = (payload) => ({
    type: Types.SET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE,
    payload,
});
export const getMaintenancePauseReasonList = (payload) => ({
    type: Types.GET_MAINTENANCE_PAUSE_REASON_LIST,
    payload,
});
export const setGetMaintenancePauseReasonList = (payload) => ({
    type: Types.SET_MAINTENANCE_PAUSE_REASON_LIST,
    payload,
});
export const deleteUnplannedFiles = (payload) => ({
    type: Types.DELETE_UNPLANNED_FILES,
    payload,
});
export const resetActionResponse = () => ({
    type: Types.RESET_ACTION_REPONSE,
});
export const resetTechnicians = () => ({
    type: Types.RESET_TECHNICIANS,
});
export const resetRootCauses = () => ({
    type: Types.RESET_ROOT_CAUSES,
});
export const resetListByStatusUnplanned_Maintenance = () => ({
    type: Types.RESET_LIST_BYSTATUS_UNPLANNED_MAINTENANCE,
});
export const resetGetBreakdownReasonPlaceListByGroupIdAndPoolRelations = () => ({
    type: Types.RESET_BDREASON_PLACELIST_BYGROUPID,
});
export const resetGetMaintenancePauseReasonList = () => ({
    type: Types.RESET_MAINTENANCE_PAUSE_REASON_LIST,
});
export const resetGetTaskHistoryByIdUnPlannedMaintenance = () => ({
    type: Types.RESET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE,
});
export const resetUnplannedFiles = () => ({
    type: Types.RESET_UNPLANNED_FILES,
});
export const resetBreakdownPoolList = () => ({
    type: Types.RESET_BD_POOL_LIST,
});
export const resetBreakdownEffectList = () => ({
    type: Types.RESET_BREAK_DOWN_EFFECT_LIST,
});
export const resetSameLevelListById = () => ({
    type: Types.RESET_SAME_LEVEL_LIST_BY_ID,
});
export const resetTaskDetailById = () => ({
    type: Types.RESET_TASK_DETAIL_BY_ID,
});
export const resetBreakdownReasonList = () => ({
    type: Types.RESET_BREAK_DOWN_REASON_LIST,
});
export const resetCreateSubTaskSuccess = () => ({
    type: Types.RESET_CREATE_SUBTASK_UNPLANNED_MAINTENANCE_SUCCESS,
});
export const resetGetBreakdownReasonDetailListByPlaceId = () => ({
    type: Types.RESET_BDREASON_DETAILLIST_BYPLACEID,
});

export const getEkedEquipmentList = (payload) => ({
    type: Types.GET_EKED_EQUIPMENT_LIST_UNPLANNED,
    payload,
});

export const setEkedEquipmentList = (payload) => ({
    type: Types.SET_EKED_EQUIPMENT_LIST_UNPLANNED,
    payload,
});

export const updateEkedEquipmentList = (payload) => ({
    type: Types.UPDATE_EKED_EQUIPMENT_LIST_UNPLANNED,
    payload,
});

export const getCurrentUsersActiveTaskId = () => ({
    type: Types.GET_CURRENT_USERS_ACTIVE_TASK_ID,
});

export const setCurrentUsersActiveTaskId = (payload) => ({
    type: Types.SET_CURRENT_USERS_ACTIVE_TASK_ID,
    payload,
});
